import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Main from '@/components/Main'
import Summary from '@/components/Summary'
import Predictions from '@/components/Predictions'
import OpenPredictions from '@/components/OpenPredictions'
import Comments from '@/components/Comments'
import Reply from '@/components/Reply'
import CreatePredictions from '@/components/CreatePredictions'
import GeneratePredictions from '@/components/GeneratePredictions'
import Ranking from '@/components/Ranking'
import EventPredictions from '@/components/EventPredictions'
import BotManagement from '@/components/BotManagement'
import Users from '@/components/Users'
import Crumbs from '@/components/Crumbs'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/main',
      component: Main,
      redirect: '/main/summary',
      children: [
        {
          path: 'summary',
          name: 'summary',
          component: Summary,
        },
        {
          path: 'predictions',
          name: 'predictions',
          component: Predictions,
        },
        {
          path: 'open_predictions',
          name: 'open_predictions',
          component: OpenPredictions,
        },
        {
          path: 'comments',
          name: 'comments',
          component: Comments,
        },
        {
          path: 'reply',
          name: 'reply',
          component: Reply,
        },
        {
          path: 'create_predictions',
          name: 'create_predictions',
          component: CreatePredictions,
        },
        {
          path: 'generate_predictions',
          name: 'generate_predictions',
          component: GeneratePredictions,
        },
        {
          path: 'ranking',
          name: 'ranking',
          component: Ranking,
        },
        {
          path: 'event_predictions',
          name: 'event_predictions',
          component: EventPredictions,
        },
        {
          path: 'bot_management',
          name: 'bot_management',
          component: BotManagement,
        },
        {
          path: 'users',
          name: 'users',
          component: Users,
        },
        {
          path: 'crumbs',
          name: 'crumbs',
          component: Crumbs,
        },
      ]
    },
  ]
})